module.exports = __webpack_public_path__ + "img/5d76b0a.jpg";